import React, { useState } from 'react';
import CustomAlert from '../components/CustomAlert';

export default function ClientEntry({ onSuccess }) {
  const [queryValue, setQueryValue] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', type: 'info' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`/api/client/orderByCode?query=${encodeURIComponent(queryValue)}&code=${code}&_t=${Date.now()}`);
      const data = await res.json();

      if (data.org && data.partners) {
        onSuccess(data.org, data.partners, queryValue, code,data.fileList);
      } else {
        setAlert({
          open: true,
          message: data.message || '查询失败，请检查输入信息是否正确',
          type: 'error'
        });
      }
    } catch (error) {
      setAlert({
        open: true,
        message: '网络连接失败，请检查网络后重试',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{
        maxWidth: '480px',
        margin: 'clamp(10px, 3vw, 20px) auto',
        padding: '0 16px',
        minHeight: 'auto',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center'
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '16px',
          padding: 'clamp(16px, 4vw, 32px)',
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
          border: '1px solid #e9ecef',
          width: '100%',
          maxWidth: '100%'
        }}>
          <div style={{
            textAlign: 'center',
            marginBottom: 'clamp(20px, 4vw, 28px)'
          }}>
            <div style={{
              marginBottom: 'clamp(12px, 3vw, 16px)',
              display: 'flex',
              justifyContent: 'center'
            }}>
              <img
                src="/police_logo.png"
                alt="警徽"
                style={{
                  width: '120px',
                  height: '120px',
                  objectFit: 'contain'
                }}
              />
            </div>
            <h1 style={{
              color: '#2c3e50',
              margin: '0 0 8px 0',
              fontSize: 'clamp(20px, 5vw, 25px)',
              fontWeight: '700',
              lineHeight: '1.3'
            }}>
              重庆章网<br/>印章业务授权管理系统
            </h1>
            <div style={{
              display: 'inline-block',
              background: 'var(--primary-color)',
              color: '#fff',
              padding: '4px 12px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '500',
              marginTop: '8px'
            }}>
              用户端
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <input
                value={queryValue}
                onChange={e => setQueryValue(e.target.value)}
                placeholder="可输入流水号/机构名称/统一社会信用代码"
                required
                style={{
                  width: '100%',
                  padding: 'clamp(10px, 3vw, 12px) clamp(12px, 4vw, 16px)',
                  border: '2px solid #e9ecef',
                  borderRadius: '8px',
                  fontSize: 'clamp(14px, 4vw, 16px)',
                  outline: 'none',
                  transition: 'all 0.2s ease',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = 'var(--primary-color)';
                  e.target.style.boxShadow = '0 0 0 3px rgba(45, 140, 240, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e9ecef';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ marginBottom: '32px' }}>
              <input
                value={code}
                onChange={e => setCode(e.target.value)}
                placeholder="请输入校验码"
                required
                style={{
                  width: '100%',
                  padding: 'clamp(10px, 3vw, 12px) clamp(12px, 4vw, 16px)',
                  border: '2px solid #e9ecef',
                  borderRadius: '8px',
                  fontSize: 'clamp(14px, 4vw, 16px)',
                  outline: 'none',
                  transition: 'all 0.2s ease',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = 'var(--primary-color)';
                  e.target.style.boxShadow = '0 0 0 3px rgba(45, 140, 240, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e9ecef';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: 'clamp(12px, 2.5vw, 14px) clamp(16px, 3.5vw, 20px)',
                background: loading ? '#dee2e6' : 'var(--primary-color)',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontSize: 'clamp(14px, 3.5vw, 16px)',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                position: 'relative',
                minHeight: 'clamp(44px, 8vw, 48px)'
              }}
              onMouseOver={(e) => {
                if (!loading) {
                  e.target.style.background = 'var(--primary-hover)';
                  e.target.style.transform = 'translateY(-1px)';
                }
              }}
              onMouseOut={(e) => {
                if (!loading) {
                  e.target.style.background = 'var(--primary-color)';
                  e.target.style.transform = 'translateY(0)';
                }
              }}
            >
              {loading ? (
                <>
                  <span style={{ opacity: 0 }}>查询</span>
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '20px',
                    height: '20px',
                    border: '2px solid transparent',
                    borderTop: '2px solid #fff',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                </>
              ) : (
                '查询订单'
              )}
            </button>
          </form>

          <div style={{
            marginTop: '24px',
            padding: '16px',
            background: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '8px'
            }}>
              <span style={{ fontSize: '16px', marginRight: '8px' }}>💡</span>
              <span style={{ fontSize: '14px', fontWeight: '600', color: '#495057' }}>
                温馨提示
              </span>
            </div>
            <p style={{
              margin: '0',
              fontSize: '13px',
              color: '#6c757d',
              lineHeight: '1.5'
            }}>
              请确保输入的信息准确无误。如有疑问，请联系相关业务人员。
            </p>
          </div>
        </div>
      </div>

      <CustomAlert
        open={alert.open}
        message={alert.message}
        type={alert.type}
        onClose={() => setAlert({ ...alert, open: false })}
      />
    </>
  );
}
